// extracted by mini-css-extract-plugin
module.exports = {"container":"SysDialog_container_2du3B","header":"SysDialog_header_2GuZ5","body":"SysDialog_body_vbIZ3","footer":"SysDialog_footer_3-g0V"};